export const configTracker = {
  actions: {
    adminConfigs: 'Configurações de adminstrador',
    compare: 'Comparar',
  },
}
